var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanies = function SvgCompanies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.395 9.8V6.2a1.2 1.2 0 0 1 1.2-1.2h7.2a1.2 1.2 0 0 1 1.2 1.2v3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.594 21.789H5V10.997a1.2 1.2 0 0 1 1.2-1.2h23.985a1.2 1.2 0 0 1 1.2 1.2V21.79h-9.594M30.184 25.387v4.8a1.2 1.2 0 0 1-1.2 1.2H7.399a1.2 1.2 0 0 1-1.2-1.2v-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.594 19.391h7.195v4.797h-7.195z"
  }))));
};
export default SvgCompanies;